export default class LoadingSpinner {
	static show() {
		const $loader = document.querySelector('.loading-spinner');
		if ($loader) {
			$loader.classList.add('is-active');
		} else {
			document.body.insertAdjacentElement('beforeend', `<div class="is-active"><img src="/assets/images/spinner.gif" /></div>`);
		}
	}

	static hide() {
		const $loader = document.querySelector('.loading-spinner');
		if ($loader) {
			$loader.classList.remove('is-active');
		}
	}
}
